"use strict";

import axios from 'axios';

class Radar {
    constructor(apiKey, options) {
        this.apiKey = apiKey;
        this.options = options;

        if (browserSupportsAllFeatures()) {
            //Send to a generic main method because all is good
            main();
        } else {
            //Punish the ancient browser with specific polyfills.
            loadScript("https://cdn.polyfill.io/v2/polyfill.min.js?features=Promise,fetch,Symbol", main)
        }
    }


    /* Method that fetches the inquiry answer from Radar and calls a callback with the answer. 	*/
    inquiry(callback) {
        callRadar(this.apiKey, this.options, callback).then(
            function (v) {
                callback(v);
            },

            function (e) {
                console.error("There was a problem calling Radar: ", e);
                callback(false);
            }
        ).catch(error => {
            console.error("Uncaught error", error);
            callback(false);
        });
    }

    /* Method that fetches the inquiry answer from Radar and toggles the visibility of the targeted element. */
    toggle(selector) {
        var o = document.querySelector(selector);
        return callRadar(this.apiKey).then(
            function (v) {
                if (o != null) {
                    o.style.display = v ? 'block' : 'none';
                } else {
                    console.error("Cannot toggle selection. Element: " + selector + " does not exist");
                }
            },
            function (e) {
                console.error("There was a problem toggling selection: " + selector + " with error: ", e);
            }
        );
    }
}


function main() {
    //This function doesn't do anything.
}


/* Function that does the calling to Radar to retrieve the answer.
 * Because IE sucks and versions less than 10 can't possibly deal with anything, if the request to Radar is mixed
 * content, we'll just error and return false. We can't just send the inquiry request through the same protocol (http(s))
 * because our F5 config will always redirect to HTTPS.
 * */
function callRadar(key, options) {
    return new Promise(function (resolve, reject) {
        let method = "post";
        let bodyFormData = new FormData();

        if (options != null) {
            //If a userID is provided, add the user_id to the post payload
            if (options.user_id) {
                bodyFormData.append('user_id',options.user_id);
            }

            if ( options.method ) {
                method = options.method;
            }
        }

        var axiosConfig = {
            method: method,
            url: RADAR_HOST + '/api/v1/inquiry/' + key,
            mode:'no-cors',
            validateStatus: false
        }

        //Get the SP cookie and set the domain_userid param
        var spCookie = getCookie("sp");
        bodyFormData.append('domain_userid', spCookie);

        //Set the data to the form post data
        axiosConfig.data = bodyFormData;

        console.log("Fetching via: " + method);
        //Fetch the inquiry from Radar
        axios(axiosConfig)
            .then(function (response) {
                if (response.status !== 200) {
                    console.error("Received bad response from Radar with status: " + response.status);
                    resolve(false);
                }
                //Got a response so return it
                resolve(response.data.answer);
            })
            .catch(function (error) {
                //Any error, just log the error and reject - exception will bubble up
                console.error("Got an error", error);
                reject(error);
            });
    });
}

/* Check to see if the browser supports the ES6+ features we need. */
function browserSupportsAllFeatures() {
    return window.Promise && window.fetch && window.Symbol;
}

/* Load the script (probably a polyfill) and then call a function when complete. */
function loadScript(src, done) {
    var js = document.createElement('script');
    js.src = src;
    js.onload = function () {
        done();
    };
    js.onerror = function () {
        new Error('Failed to load script ' + src);
    };
    document.head.appendChild(js);
}

/* Extract a cookie from the browser */
function getCookie(name) {
    var cookieValue = "; " + document.cookie;
    var cookieParts = cookieValue.split("; " + name + "=");
    if (cookieParts.length == 2) return cookieParts.pop().split(";").shift();
}


module.exports = (apiKey, options) => {
    return new Radar (apiKey, options);
};